export default __webpack_public_path__ + "static/media/Background 5_00059.dd08e40c.png";